module.exports = __webpack_public_path__ + "static/media/02.3d3bcb3a.png";